import React from "react";

/**
 * Entity type checkboxes. variant="floating" overlays the graph (default);
 * variant="inline" inserts in document flow (legacy).
 */
const EntityTypeFilter = ({
  showEntityTypesPanel,
  availableEntityTypes,
  selectedEntityTypes,
  setSelectedEntityTypes,
  onClose,
  typeColors = {},
  typeLabels = {},
  tone = "dark",
  variant = "floating",
}) => {
  if (!showEntityTypesPanel) return null;

  const isLight = tone === "light";
  const isInline = variant === "inline";

  const shellClass = isInline
    ? isLight
      ? "shrink-0 border-b border-slate-200 bg-white px-3 py-3 md:px-4 z-[5]"
      : "shrink-0 border-b border-gray-700 bg-gray-800 px-3 py-3 md:px-4 z-[5]"
    : isLight
      ? "fixed inset-x-0 bottom-0 z-30 max-h-[70dvh] overflow-y-auto rounded-t-2xl border border-slate-200 bg-white p-4 pb-[max(1rem,env(safe-area-inset-bottom))] shadow-2xl md:absolute md:inset-x-auto md:bottom-4 md:left-4 md:z-20 md:max-h-none md:max-w-sm md:w-[min(22rem,calc(100%-2rem))] md:rounded-lg md:pb-4 md:shadow-lg"
      : "fixed inset-x-0 bottom-0 z-30 max-h-[70dvh] overflow-y-auto rounded-t-2xl border border-gray-600 bg-gray-800 p-4 pb-[max(1rem,env(safe-area-inset-bottom))] shadow-2xl md:absolute md:inset-x-auto md:bottom-4 md:left-4 md:z-20 md:max-h-none md:max-w-sm md:w-[min(22rem,calc(100%-2rem))] md:rounded-lg md:pb-4 md:shadow-lg";

  const titleClass = isLight ? "text-sm font-medium text-slate-800" : "text-sm text-gray-300";
  const labelClass = isLight ? "text-slate-800 text-sm" : "text-white text-sm";
  const closeClass = isLight
    ? "text-slate-500 hover:text-slate-800 transition-colors"
    : "text-gray-400 hover:text-white transition-colors";
  const inputClass = isLight
    ? "rounded border-slate-300 bg-white text-blue-600 focus:ring-blue-500"
    : "rounded border-gray-600 bg-gray-700 text-blue-600 focus:ring-blue-500";
  const borderMuted = isLight ? "border-slate-200" : "border-gray-600";
  const subtleBtn = isLight
    ? "text-xs text-slate-500 hover:text-slate-800 transition-colors"
    : "text-xs text-gray-400 hover:text-white transition-colors";

  return (
    <div className={shellClass}>
      <div className="flex items-center justify-between mb-3 gap-2">
        <div className={titleClass}>Filter by entity type</div>
        <button
          type="button"
          onClick={onClose}
          className={closeClass}
          aria-label="Close filter panel"
        >
          ✕
        </button>
      </div>
      <div className={`space-y-2 max-h-60 overflow-y-auto ${isInline ? "" : ""}`}>
        {availableEntityTypes.map((type) => (
          <label
            key={type}
            className="flex items-center space-x-2 cursor-pointer"
          >
            <span
              className="inline-block w-3 h-3 rounded-sm border"
              style={{
                backgroundColor:
                  typeColors[type]?.bg || typeColors.default?.bg || "#6b7280",
                borderColor:
                  typeColors[type]?.border ||
                  typeColors.default?.border ||
                  "#9ca3af",
              }}
            />
            <input
              type="checkbox"
              checked={selectedEntityTypes.includes(type)}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedEntityTypes((prev) => [...prev, type]);
                } else {
                  setSelectedEntityTypes((prev) =>
                    prev.filter((t) => t !== type)
                  );
                }
              }}
              className={inputClass}
            />
            <span className={labelClass}>{typeLabels[type] || type}</span>
          </label>
        ))}
      </div>
      <div className={`mt-3 pt-3 border-t ${borderMuted}`}>
        <button type="button" onClick={() => setSelectedEntityTypes([])} className={subtleBtn}>
          Clear all
        </button>
      </div>
    </div>
  );
};

export default EntityTypeFilter;
